import { Component, Input, OnInit } from '@angular/core';
import * as padStart from 'lodash/padStart';

import { Wind } from '../models/wind.model';


@Component({
  selector: 'app-wind',
  templateUrl: './wind.component.html',
  styleUrls: ['./wind.component.scss'],
  preserveWhitespaces: true
})
export class WindComponent implements OnInit {
  @Input() wind: Wind;

  constructor() { }

  ngOnInit() {
  }

  /**
   * Returns formatted wind direction (left-padded with zeros)
   */
  get direction(): string {
    return this.wind.direction ? padStart(this.wind.direction, 3, '0') : null;
  }
}
